import { graphql } from '../../../../../globals/api/requests';

export const fetchSotyAwardsByStoreId = (id: number) => {
  return graphql(
    `
      query storePage($id: Int!) {
        store(id: $id) {
          id
          name
          storeOfTheYearAwards {
            id
            name
            resourceName
            logo
            year
            mainAward
            isSpecial
            isPrimary
          }
        }
      }
    `,
    { id }
  );
};
